import type { MerchandiseOrderCreationItem } from 'api/order'
import getMerchandiseItemViews from 'checkout/selectors/view/itemViews/getMerchandiseItemViews'
import { createSelector } from 'reselect'
import { getAllPromoCodeItemDiscounts } from '../checkout'
import type { PromoItemDiscountsWithStatus } from 'lib/promo/promoMappers'
import { filterItemDiscounts } from 'lib/promo/filterItemDiscounts'
import formatItemDiscount from 'lib/payment/formatDiscountItem'

const getFormattedMerchandiseItems = createSelector(
  (state: App.State) => getMerchandiseItemViews(state),
  (state: App.State) => getAllPromoCodeItemDiscounts(state),
  (views: App.WithDataStatus<Array<App.Checkout.MerchandiseItemView>>, itemDiscounts: PromoItemDiscountsWithStatus): Array<MerchandiseOrderCreationItem> => {
    const thisItemDiscounts = filterItemDiscounts({ itemDiscounts: itemDiscounts.itemDiscounts, lookup: { specificType: 'cart-id-based', cartItemIds: views.data.map(view => view.item.itemId ?? '') } })
    return views.data.map((view): MerchandiseOrderCreationItem => {
      return {
        type: 'merchandise',
        transaction_key: view.item.transactionKey,
        total: view.totals.price,
        shippingGroup: view.shippingGroupId,
        variantId: view.item.variantId,
        itemDiscounts: thisItemDiscounts.map(d => formatItemDiscount(d, view.item.transactionKey)),
      }
    })
  })

export default getFormattedMerchandiseItems
